export default {
  h1: {
    fontWeight: 500,
    fontSize: 29,
    letterSpacing: '-0.24px',
    '@media (min-width:800px)': {
      fontSize: 35,
    },
  },
  h2: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.24px',
    '@media (min-width:800px)': {
      fontSize: 29,
    },
  },
  h3: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px',
    '@media (min-width:800px)': {
      fontSize: 24,
    },
  },
  h4: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.06px',
    '@media (min-width:800px)': {
      fontSize: 20,
    },
  },
  h5: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '-0.05px',
    '@media (min-width:800px)': {
      fontSize: 16,
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 12,
    letterSpacing: '-0.05px',
    '@media (min-width:800px)': {
      fontSize: 14,
    },
  },
  h7: {
    fontWeight: 300,
    fontSize: 10,
    color: 'dimgrey',
    letterSpacing: '-0.03px',
    '@media (min-width:800px)': {
      fontSize: 12,
    },
  },
  overline: {
    fontWeight: 500
  }
};
